import { createSelector } from 'reselect';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';

const location = (state) => state.routingCompat;
const report = (state) => state.serverStorage.store.report;
const reportUtils = ReportComponent.utils;

export const getCheckedKeys = createSelector(
    location,
    report,
    (location, report) => {
        const urlParams = new URLSearchParams(location?.search);
        const urlMetrics = urlParams.get('metrics');
        
        const metrics = urlMetrics || report?.metrics || reportUtils.getDefStrMetric();
        
        return Array.isArray(metrics) ? metrics : reportUtils.getKeysMetric(metrics);
    }
);

export const getMetrics = createSelector(
    location,
    report,
    (location, report) => {
        const urlParams = new URLSearchParams(location?.search);
        const urlMetrics = urlParams.get('metrics');
        
        return urlMetrics || report?.metrics || reportUtils.getDefStrMetric();
    }
);

export const mainSelector = createSelector(
    report,
    () => {
        return reportUtils.getMultiLevelHeaderNames();
    }
);
